import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { FlatType } from '../../store/offer';
import { ENewObjectRoomType, IRoomInfo } from '../../types/newobject/newbuildingRoomInfo';
import { FOfferType, getOfferType, isFlat } from '../../utils/offer_type';

const roomTypes: ENewObjectRoomType[] = [
  ENewObjectRoomType.Bed,
  ENewObjectRoomType.Room,
  ENewObjectRoomType.Share,
  ENewObjectRoomType.Studio,
  ENewObjectRoomType.OneRoom,
  ENewObjectRoomType.TwoRoom,
  ENewObjectRoomType.ThreeRoom,
  ENewObjectRoomType.FourRoom,
  ENewObjectRoomType.FiveRoom,
  ENewObjectRoomType.Large,
  ENewObjectRoomType.OpenPlan,
];

export function getRoomWeight(type?: ENewObjectRoomType | null): number {
  if (!type) {
    return -1;
  }

  return roomTypes.indexOf(type);
}

export function mapOfferToRoomType(offer: IOfferSchema): ENewObjectRoomType | undefined {
  const offerType = getOfferType(offer);

  if (offerType === FOfferType.Bed) {
    return ENewObjectRoomType.Bed;
  }

  if (offerType === FOfferType.Room) {
    return ENewObjectRoomType.Room;
  }

  if (offerType === FOfferType.FlatShared) {
    return ENewObjectRoomType.Share;
  }

  if (isFlat(offerType)) {
    if (offer.flatType === FlatType.Studio) {
      return ENewObjectRoomType.Studio;
    }

    if (offer.flatType === FlatType.OpenPlan) {
      return ENewObjectRoomType.OpenPlan;
    }

    // tslint:disable-next-line:switch-default
    switch (offer.roomsCount) {
      case 1:
        return ENewObjectRoomType.OneRoom;
      case 2:
        return ENewObjectRoomType.TwoRoom;
      case 3:
        return ENewObjectRoomType.ThreeRoom;
      case 4:
        return ENewObjectRoomType.FourRoom;
      case 5:
        return ENewObjectRoomType.FiveRoom;
    }

    if (offer.roomsCount > 5) {
      return ENewObjectRoomType.Large;
    }
  }

  return undefined;
}

export function getFilteredRoomsInfo(roomsInfo: IRoomInfo[], offer: IOfferSchema): IRoomInfo[] {
  const filteredRoomsInfo = roomsInfo.filter(Boolean);

  if (filteredRoomsInfo.length <= 3) {
    return filteredRoomsInfo;
  }

  const currentOfferRoomType = mapOfferToRoomType(offer);

  filteredRoomsInfo.sort((a, b) => getRoomWeight(a.type) - getRoomWeight(b.type));

  const index = filteredRoomsInfo.findIndex(({ type }) => type === currentOfferRoomType);

  if (index > 0) {
    const lastItem = filteredRoomsInfo[index + 1];

    return [filteredRoomsInfo[index - 1], filteredRoomsInfo[index], ...(lastItem ? [lastItem] : [])];
  }

  return filteredRoomsInfo.slice(0, 3);
}
